export default __webpack_public_path__ + "static/media/guide_dev_08.007735db.md";